import React from "react";
import { createPortal } from 'react-dom';

const BodyPortal=props=> {
  return(
    createPortal(<div id='exzModal' className={`exz-body-portal ${props.className}`}>{props.children}</div>,document.body)

  ) 
}

export default BodyPortal